import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, LayoutDashboard, RefreshCw } from 'lucide-react';
import { fmt, fmtDate, fmtRelative } from './formatters';

function KpiTile({ label, value, hint }) {
  return (
    <div className="col-6 col-md-3">
      <div className="ahri-dash-kpi">
        <div className="ahri-dash-kpi__label">{label}</div>
        <div className="ahri-dash-kpi__value">{value}</div>
        {hint ? <div className="ahri-dash-kpi__hint mt-1">{hint}</div> : null}
      </div>
    </div>
  );
}

function DashboardHero({
  loading,
  onRefresh,
  generatedAt,
  ahriTotal,
  productTotal,
  completeMatches,
  qualityScore,
  lastAhriSync,
  pipelineActive,
}) {
  return (
    <div className="ahri-dash-hero p-4 p-lg-4 mb-4">
      <div className="ahri-dash-hero__inner ps-2 ps-lg-3">
        <div className="d-flex flex-column flex-lg-row align-items-lg-start justify-content-lg-between gap-4 mb-4">
          <div className="flex-grow-1">
            <span className="badge ahri-dash-hero__eyebrow mb-3">
              <LayoutDashboard size={13} className="me-1 opacity-75" />
              Operations overview
            </span>
            <h1 className="h3 ahri-dash-hero__title mb-2">AHRI Pipeline Dashboard</h1>
            <p className="mb-0 ahri-dash-hero__lead pe-lg-4">
              Track each pipeline step — AHRI GraphQL sync, product index, data quality, inventory,
              product mapping, and attribute mapping — with last-synced times and live status.
            </p>
            {pipelineActive ? (
              <span className="badge ahri-dash-hero__status mt-2">
                <Activity size={12} className="me-1" />
                Pipeline job in progress
              </span>
            ) : null}
          </div>
          <div className="d-flex flex-wrap gap-2">
            <button
              type="button"
              className="btn ahri-dash-hero__btn-refresh d-inline-flex align-items-center gap-2"
              onClick={onRefresh}
              disabled={loading}
            >
              <RefreshCw size={16} className={loading ? 'ahri-dash-spin' : ''} />
              {loading ? 'Refreshing…' : 'Refresh'}
            </button>
            <Link to="/ahri" className="btn ahri-dash-hero__btn-link btn-outline-secondary">AHRI Data</Link>
            <Link to="/ahri/solr" className="btn ahri-dash-hero__btn-link btn-outline-secondary">Search</Link>
          </div>
        </div>
        <div className="row g-3">
          <KpiTile
            label="AHRI systems"
            value={fmt(ahriTotal)}
            hint={lastAhriSync ? `GraphQL sync ${fmtRelative(lastAhriSync)}` : 'No GraphQL sync yet'}
          />
          <KpiTile label="Products" value={fmt(productTotal)} hint="Catalog database" />
          <KpiTile label="Complete matches" value={fmt(completeMatches)} hint="AHRI ↔ product" />
          <KpiTile
            label="Data quality"
            value={qualityScore != null ? `${qualityScore}%` : '—'}
            hint={generatedAt ? `Updated ${fmtRelative(generatedAt)}` : ''}
          />
        </div>
        {generatedAt ? (
          <div className="d-flex align-items-center gap-2 mt-3 ahri-dash-hero__meta">
            <Activity size={14} className="opacity-75" />
            Snapshot {fmtDate(generatedAt)}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default DashboardHero;
